// src/index.tsx
import { jsx } from "react/jsx-runtime";
function Button({ children, className = "", tone = "secondary", ...props }) {
  return /* @__PURE__ */ jsx("button", { className: `pf-button pf-button--${tone} ${className}`.trim(), ...props, children });
}
export {
  Button
};
